import {
  Id,
  Identifiable,
  Document,
  Task,
  Folder,
  List,
  Event,
  Milestone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

const ENDPOINTS = {
  TASK: "/tasks/",
  LIST: "/activities/",
  EVENT: "/events/",
  MILESTONE: "/milestones/",
  EXPENSE: "/expenses/",
};

function findInFolder(
  root: Identifiable<Folder>,
  uuid: string,
): Identifiable<Folder> | Identifiable<Document> | null {
  if (root.uuid === uuid) {
    return root;
  }
  for (const child of root.children) {
    if (child.type === "folder") {
      const result = findInFolder(child, uuid);
      if (result) {
        return result;
      }
    } else {
      if (child.uuid === uuid) {
        return child;
      }
    }
  }
  return null;
}

function retrieveElementAttachments(
  httpClient: HttpClient,
  docHttpClient: HttpClient,
) {
  return (
    elementId: Id,
    elementType: "TASK" | "LIST" | "EVENT" | "MILESTONE" | "EXPENSE",
    projectId: Id,
  ) =>
    httpClient
      .sendHttpRequest<Task | List | Event | Milestone>({
        endpoint: `${ENDPOINTS[elementType]}${elementId}`,
        method: HttpMethods.GET,
      })
      .then((task) =>
        docHttpClient
          .sendHttpRequest<any>({
            endpoint: `/api/folder/project/${projectId}/root`,
            method: HttpMethods.POST,
          })
          .then((documents) => {
            const attachments: Identifiable<Document>[] = [];
            if (!task.attachments)
              return {
                elementId,
                elementType,
                attachments,
              };

            for (const attachment of task.attachments) {
              const doc = findInFolder(
                documents,
                attachment.attachedEntityUuid,
              );
              if (doc) {
                attachments.push(doc as Identifiable<Document>);
              }
            }
            return {
              elementId,
              elementType,
              attachments,
            };
          }),
      );
}

export { retrieveElementAttachments };
